export const EXPERIMENTS = [
  {
    id: "001",
    slug: "shader-study-001",
    title: "SHADER STUDY 001",
    summary: "Real-time visual exploration.",
    description:
      "An iridescent black liquid-metal surface driven by layered procedural noise. The study exists to find the point where interference fringes read as material rather than as effect — and to measure what that costs per frame.",
    tech: ["GLSL", "Raymarching", "Procedural noise", "WebGL2"],
    image:
      "https://static.prod-images.emergentagent.com/jobs/5936bd48-65ed-4320-8e36-e81eb45e928e/images/6e6fe54e73738bccd914e62cc8a963fb868f6a62861d543b48d0b22dbd086db3.jpeg",
    alt: "Shader Study 001 — iridescent black liquid metal surface with violet and cyan interference fringes",
    seoTitle: "Shader Study 001 — Real-Time Visual Exploration | Elentara Experiments",
    seoDescription:
      "Shader Study 001 from the Elentara experiments lab: a real-time GLSL exploration of iridescent liquid-metal interference under a strict frame budget.",
  },
  {
    id: "002",
    slug: "generative-type-002",
    title: "GENERATIVE TYPE 002",
    summary: "Procedural typography and variable form.",
    description:
      "A single glyph drawn simultaneously at many weights, layered until the contours produce a moiré depth field. The question is how much structural information a letterform can lose before it stops being read.",
    tech: ["Canvas 2D", "Procedural contours", "Variable axes", "Type research"],
    image:
      "https://static.prod-images.emergentagent.com/jobs/5936bd48-65ed-4320-8e36-e81eb45e928e/images/9d1fa2ce1a0e6412fddfd1273ca47d28a058ea165b5d31e2c083af22122e3538.jpeg",
    alt: "Generative Type 002 — a glyph rendered as layered contours producing a moiré depth effect",
    seoTitle: "Generative Type 002 — Procedural Typography | Elentara Experiments",
    seoDescription:
      "Generative Type 002 from the Elentara experiments lab: procedural typography and variable form research into how much structure a letterform can lose.",
  },
  {
    id: "003",
    slug: "spatial-test-003",
    title: "SPATIAL TEST 003",
    summary: "Experimental spatial interface.",
    description:
      "Translucent panels arranged in true depth rather than in a stack. The test measures whether depth alone can carry information hierarchy once shadows, borders and size cues are removed.",
    tech: ["Three.js", "Depth-of-field", "Spatial UI", "Interaction research"],
    image:
      "https://static.prod-images.emergentagent.com/jobs/5936bd48-65ed-4320-8e36-e81eb45e928e/images/0a2dd61a196d310b4b085dda2728068da04d791512e0432f9f088b49cc90d566.jpeg",
    alt: "Spatial Test 003 — translucent glass interface panels arranged in three-dimensional depth",
    seoTitle: "Spatial Test 003 — Experimental Spatial Interface | Elentara Experiments",
    seoDescription:
      "Spatial Test 003 from the Elentara experiments lab: an experimental spatial interface testing whether depth alone can carry information hierarchy.",
  },
  {
    id: "004",
    slug: "fluid-system-004",
    title: "FLUID SYSTEM 004",
    summary: "Fluid and particle simulation study.",
    description:
      "An ink plume unfurling through dark liquid, with fine particles trailing in vortex sheets. The study is about restraint: finding the smallest particle count that still reads as volume.",
    tech: ["Fluid simulation", "GPU particles", "Vortex fields", "Compute passes"],
    image:
      "https://static.prod-images.emergentagent.com/jobs/5936bd48-65ed-4320-8e36-e81eb45e928e/images/939440d900bcd759c1928acb91de1f0e1181ef482cf1c006afc6dc334e71dd7d.jpeg",
    alt: "Fluid System 004 — violet ink plume unfurling through black liquid with particle vortex sheets",
    seoTitle: "Fluid System 004 — Fluid & Particle Simulation | Elentara Experiments",
    seoDescription:
      "Fluid System 004 from the Elentara experiments lab: a fluid and particle simulation study finding the minimum particle count that still reads as volume.",
  },
  {
    id: "005",
    slug: "audio-reactive-geometry-005",
    title: "AUDIO-REACTIVE GEOMETRY 005",
    summary: "Visual systems driven by sound.",
    description:
      "A faceted form fractured into concentric rings that expand as a waveform. Each radius answers a different frequency band, so the geometry becomes a spectrum without ever drawing a bar.",
    tech: ["Web Audio API", "FFT analysis", "Instanced geometry", "Emissive shading"],
    image:
      "https://static.prod-images.emergentagent.com/jobs/5936bd48-65ed-4320-8e36-e81eb45e928e/images/35ca6ba006663499754e63ff7c9d844790912b9f8f81395651c919876334db7e.jpeg",
    alt: "Audio-Reactive Geometry 005 — faceted chrome form fractured into expanding concentric emissive rings",
    seoTitle: "Audio-Reactive Geometry 005 — Sound-Driven Visuals | Elentara Experiments",
    seoDescription:
      "Audio-Reactive Geometry 005 from the Elentara experiments lab: visual systems driven by sound, turning frequency bands into geometry instead of bars.",
  },
];

export const getExperiment = (slug) => EXPERIMENTS.find((e) => e.slug === slug);
